import {

  GETHRTRAININGHISTORYBYID,
  GETHRTRAININGHISTORYALLDETAILS,
  GETHRTRAININGHISTORY,
  CREATEHRTRAININGHISTORY,
  UPDATEHRTRAININGHISTORY,
  DELETEHRTRAININGHISTORY,

  HRLOANGENERATEMANDATE,
  INITIATELOANHRPAYOUT,
  GET_HR_STAFF_LOAN_REQUESTS,
  GET_HR_STAFF_LOAN_REQUEST_DETAILS,
  RAISE_HR_STAFF_LOAN_REQUEST,
  APPROVE_HR_STAFF_LOAN_REQUEST,
  REJECT_HR_STAFF_LOAN_REQUEST,
  CANCEL_HR_STAFF_LOAN_REQUEST,

  UPDATEHRPAYYROLLACCURE,
  CLEAR_HR_RECPIPELINE,
  CLEAR_HRINFO,
  GETHRRECRUITMENTINFOBYID,
  GETHRRECRUITMENTINFOHISTORYBYID,
  GETHRRECRUITMENTINFOHISTORYALLDETAILS,
  GETHRRECRUITMENTSTAGESBYID,
  GETHRRECRUITMENTSTAGESALLDETAILS,
  CLEAR_HR_SETUPACL,
  CLEAR_HRINFOHISTORY,
  GETHRSETUPACLLIST,
  CREATEHRSETUPACLLIST,
  UPDATEHRSETUPACLLIST,
  DELETEHRSETUPACLLIST,
  GETHRLOANDOCUMENTS,
  CREATEHRLOANDOCUMENTS,
  UPDATEHRLOANDOCUMENTS,
  DELETEHRLOANDOCUMENTS,
  GETHRLOANPOLICYINFOHISTORY,
  CREATEHRLOANPOLICYINFOHISTORY,
  UPDATEHRLOANPOLICYINFOHISTORY,
  DELETEHRLOANPOLICYINFOHISTORY,
  SENDHRSMS,
  GETHRPAYROLLLOANSCHEDULEINFO,
  CREATEHRPAYROLLLOANREPAYMANUAL,
  CREATEHRPAYROLLLOANREPAYPAYROLL,
  CREATEHRPAYROLLLOANPREPAYFULL,
  CREATEHRPAYROLLLOANPREPAYPPARTIAL,
  CREATEHRPAYROLLLOANADDONINTERESTLOAN,

  ISSUEHRPAYROLLLOANISSUE,
  GETHRPAYROLLLOANISSUE,
  CREATEHRPAYROLLLOANISSUE,
  UPDATEHRPAYROLLLOANISSUE,
  DELETEHRPAYROLLLOANISSUE,
  SENDHRCUSTOMTEMPEMAIL,

  CREATEHRPAYYROLLPAYOUT,
  CREATEHRPAYYROLLACCURE,
  REVERTHRPAYYROLLACCURE,
  GETHRASSETSLIST,
  CREATEHRASSETSLIST,
  UPDATEHRASSETSLIST,
  DELETEHRASSETSLIST,
  GETHRRECRUITMENTSHIFTREQUESTS,
  CREATEHRRECRUITMENTSHIFTREQUESTS,
  UPDATEHRRECRUITMENTSHIFTREQUESTS,
  DELETEHRRECRUITMENTSHIFTREQUESTS,
  GETHRRECRUITMENTPERFORMANCEOBJECTIVE,
  CREATEHRRECRUITMENTPERFORMANCEOBJECTIVE,
  UPDATEHRRECRUITMENTPERFORMANCEOBJECTIVE,
  DELETEHRRECRUITMENTPERFORMANCEOBJECTIVE,
  GETHRRECRUITMENTPERFORMANCEMEETINGS,
  CREATEHRRECRUITMENTPERFORMANCEMEETINGS,
  UPDATEHRRECRUITMENTPERFORMANCEMEETINGS,
  DELETEHRRECRUITMENTPERFORMANCEMEETINGS,
  GETHRRECRUITMENTPERFORMANCEKRA,
  CREATEHRRECRUITMENTPERFORMANCEKRA,
  UPDATEHRRECRUITMENTPERFORMANCEKRA,
  DELETEHRRECRUITMENTPERFORMANCEKRA,
  GETHRRECRUITMENTPERFORMANCEQA,
  CREATEHRRECRUITMENTPERFORMANCEQA,
  UPDATEHRRECRUITMENTPERFORMANCEQA,
  DELETEHRRECRUITMENTPERFORMANCEQA,
  GETHRRECRUITMENTPOLICIES,
  CREATEHRRECRUITMENTPOLICIES,
  UPDATEHRRECRUITMENTPOLICIES,
  DELETEHRRECRUITMENTPOLICIES,
  GETHREMAIL,
  CREATEHREMAIL,
  UPDATEHREMAIL,
  DELETEHREMAIL,
  GETHRRECRUITMENTMASTERTASK,
  CREATEHRRECRUITMENTMASTERTASK,
  UPDATEHRRECRUITMENTMASTERTASK,
  DELETEHRRECRUITMENTMASTERTASK,
  GETHRRECRUITMENTSURVEYRESPONSE,
  CREATEHRRECRUITMENTSURVEYRESPONSE,
  UPDATEHRRECRUITMENTSURVEYRESPONSE,
  DELETEHRRECRUITMENTSURVEYRESPONSE,
  GETHRRECRUITMENTPIPELINESKILLZONE,
  CREATEHRRECRUITMENTPIPELINESKILLZONE,
  UPDATEHRRECRUITMENTPIPELINESKILLZONE,
  DELETEHRRECRUITMENTPIPELINESKILLZONE,
  GETHRRECRUITMENTCANDIDATERESUME,
  CREATEHRRECRUITMENTCANDIDATERESUME,
  UPDATEHRRECRUITMENTCANDIDATERESUME,
  DELETEHRRECRUITMENTCANDIDATERESUME,
  GETHRRECRUITMENTINFO,
  CREATEHRRECRUITMENTINFO,
  UPDATEHRRECRUITMENTINFO,
  DELETEHRRECRUITMENTINFO,
  GETHRRECRUITMENTINFOHISTORY,
  CREATEHRRECRUITMENTINFOHISTORY,
  UPDATEHRRECRUITMENTINFOHISTORY,
  DELETEHRRECRUITMENTINFOHISTORY,
  GETHRRECRUITMENTCANDIDATENOTE,
  CREATEHRRECRUITMENTCANDIDATENOTE,
  UPDATEHRRECRUITMENTCANDIDATENOTE,
  DELETEHRRECRUITMENTCANDIDATENOTE,
  GETHRRECRUITMENTCANDIDATEEMAIL,
  CREATEHRRECRUITMENTCANDIDATEEMAIL,
  UPDATEHRRECRUITMENTCANDIDATEEMAIL,
  DELETEHRRECRUITMENTCANDIDATEEMAIL,
  GETHRRECRUITMENTCANDIDATE,
  CREATEHRRECRUITMENTCANDIDATE,
  UPDATEHRRECRUITMENTCANDIDATE,
  DELETEHRRECRUITMENTCANDIDATE,
  GETHRRECRUITMENTPIPELINE,
  CREATEHRRECRUITMENTPIPELINE,
  UPDATEHRRECRUITMENTPIPELINE,
  DELETEHRRECRUITMENTPIPELINE,
  GETHRRECRUITMENTSKILLZONE,
  CREATEHRRECRUITMENTSKILLZONE,
  UPDATEHRRECRUITMENTSKILLZONE,
  DELETEHRRECRUITMENTSKILLZONE,
  GETHRRECRUITMENTSTAGES,
  CREATEHRRECRUITMENTSTAGES,
  UPDATEHRRECRUITMENTSTAGES,
  DELETEHRRECRUITMENTSTAGES,
  GETHRRECRUITMENTMAIN,
  CREATEHRRECRUITMENTMAIN,
  UPDATEHRRECRUITMENTMAIN,
  DELETEHRRECRUITMENTMAIN,
  GETHRPAYROLLEARNINGDEDUCTION,
  CREATEHRPAYROLLEARNINGDEDUCTION,
  UPDATEHRPAYROLLEARNINGDEDUCTION,
  DELETEHRPAYROLLEARNINGDEDUCTION,
  CREATEHRSTAFFBANKINFORMATION,
  CREATEHRSTAFFBASICINFORMATION,
  CREATEHRSTAFFDOCUMENTINFORMATION,
  CREATEHRSTAFFLEAVEINFORMATION,
  CREATEHRSTAFFMEDIAINFORMATION,
  CREATEHRSTAFFPAYROLLINFORMATION,
  DELETEHRSTAFFBANKINFORMATION,
  DELETEHRSTAFFBASICINFORMATION,
  DELETEHRSTAFFBASICINFORMATIONEVERYTHING,
  DELETEHRSTAFFDOCUMENTINFORMATION,
  DELETEHRSTAFFLEAVEINFORMATION,
  DELETEHRSTAFFMEDIAINFORMATION,
  DELETEHRSTAFFPAYROLLINFORMATION,
  GETHRSTAFFBANKINFORMATION,
  GETHRSTAFFBANKINFORMATIONBYID,
  GETHRSTAFFBASICINFORMATION,
  GETHRSTAFFBASICINFORMATIONBYID,
  GETHRSTAFFBASICINFORMATIONBYROLL,
  GETHRSTAFFDOCUMENTINFORMATION,
  GETHRSTAFFDOCUMENTINFORMATIONBYID,
  GETHRSTAFFLEAVEINFORMATION,
  GETHRSTAFFLEAVEINFORMATIONBYID,
  GETHRSTAFFMEDIAINFORMATION,
  GETHRSTAFFMEDIAINFORMATIONBYID,
  GETHRSTAFFPAYROLLINFORMATION,
  GETHRSTAFFPAYROLLINFORMATIONBYID,
  UPDATEHRSTAFFBANKINFORMATION,
  UPDATEHRSTAFFBASICINFORMATION,
  UPDATEHRSTAFFBASICINFORMATIONFORALLTABLES,
  UPDATEHRSTAFFBASICINFORMATION1,
  UPDATEHRSTAFFDOCUMENTINFORMATION,
  UPDATEHRSTAFFLEAVEINFORMATION,
  UPDATEHRSTAFFMEDIAINFORMATION,
  UPDATEHRSTAFFPAYROLLINFORMATION,
  GETHROFFBOARDRESIGNATION,
  CREATEHROFFBOARDRESIGNATION,
  UPDATEHROFFBOARDRESIGNATION,
  DELETEHROFFBOARDRESIGNATION,

  axios,
  baseURL,
  ServiceURL,
  CLEAR_HR_STAFF,
  GETHRASSETSALL,
  CREATEHRASSETSALL,
  UPDATEHRASSETSALL,
  DELETEHRASSETSALL,

} from "./types";


const getHeaders = () => ({
  "Content-Type": "application/json",
  "Authorization": `Bearer ${localStorage.getItem("token")}`
});

export const createHRStaff = (Staffdata) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: Staffdata,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHRSTAFFBASICINFORMATION,
        payload: response.data,
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getHRStaff = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFBASICINFORMATION,
        payload: response.data,
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getHRStaffbyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/getallbyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFBASICINFORMATIONBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getHRStaffbyRoll = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/getallbyroll",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFBASICINFORMATIONBYROLL,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateHRStaff = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFBASICINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateStaffIdForAllTables = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/updateStaffid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFBASICINFORMATIONFORALLTABLES,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateHRStaff1 = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/update1",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFBASICINFORMATION1,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteHRStaff = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFBASICINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteHRStaffEverything = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffbasicinformation/deleteAllStaff",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFBASICINFORMATIONEVERYTHING,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createStaffpayroll = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffpayrollinformation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHRSTAFFPAYROLLINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffpayroll = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffpayrollinformation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFPAYROLLINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffpayrollbyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffpayrollinformation/getallbyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFPAYROLLINFORMATIONBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateStaffpayroll = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffpayrollinformation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFPAYROLLINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteStaffpayroll = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffpayrollinformation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFPAYROLLINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createStaffleave = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffleaveinformation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHRSTAFFLEAVEINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffleave = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffleaveinformation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFLEAVEINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffleavesbyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffleaveinformation/getallbyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFLEAVEINFORMATIONBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateStaffleave = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffleaveinformation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFLEAVEINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteStaffleave = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffleaveinformation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFLEAVEINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createStaffbank = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbankinformation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHRSTAFFBANKINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffbank = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbankinformation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFBANKINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffbankbyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffbankinformation/getallbyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFBANKINFORMATIONBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateStaffbank = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffbankinformation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFBANKINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteStaffbank = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffbankinformation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFBANKINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createStaffmedia = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffmediainformation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHRSTAFFMEDIAINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffmedia = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffmediainformation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFMEDIAINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffmediabyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffmediainformation/getallbyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFMEDIAINFORMATIONBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateStaffmedia = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffmediainformation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFMEDIAINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteStaffmedia = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffmediainformation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFMEDIAINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};



export const createStaffdocument = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffdocumentinformation/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHRSTAFFDOCUMENTINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffdocument = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffdocumentinformation/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFDOCUMENTINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStaffdocumentbyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstaffdocumentinformation/getallbyid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETHRSTAFFDOCUMENTINFORMATIONBYID,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateStaffdocument = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitalehrstaffdocumentinformation/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHRSTAFFDOCUMENTINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteStaffdocument = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitalehrstaffdocumentinformation/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHRSTAFFDOCUMENTINFORMATION,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHRPayrollEarningDeduction = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrpayrollearndeduct/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRPAYROLLEARNINGDEDUCTION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRPayrollEarningDeduction = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrpayrollearndeduct/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLEARNINGDEDUCTION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRPayrollEarningDeduction = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrpayrollearndeduct/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRPAYROLLEARNINGDEDUCTION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRPayrollEarningDeduction = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrpayrollearndeduct/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRPAYROLLEARNINGDEDUCTION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentSkillZone = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrskillzone/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTSKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentSkillZone = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrskillzone/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTSKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentSkillZone = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrskillzone/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTSKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentSkillZone = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrskillzone/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTSKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentStages = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrstage/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTSTAGES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
// export const getHRRecruitmentStagesById = (data) => (dispatch) => {
//   console.log(data)
//   var config = {
//     method: "post", url: baseURL + "/api/setuphospitalehrstage/byid",
//     headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
//   };
//   return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTSTAGESBYID, payload: response.data, }); }).catch(function (error) { console.log(error); });
// };
export const getHRRecruitmentStagesById = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstage/byid",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({ type: GETHRRECRUITMENTSTAGESBYID, payload: response.data });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const getHRRecruitmentStagesAllDetails = (data) => (dispatch) => {
  console.log(data);
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitalehrstage/getalldetails",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({ type: GETHRRECRUITMENTSTAGESALLDETAILS, payload: response.data });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const createHRRecruitmentStages = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrstage/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: CREATEHRRECRUITMENTSTAGES, payload: response.data, });
    return response.data.data;
  }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentStages = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrstage/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTSTAGES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentStages = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrstage/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTSTAGES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentMain = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitment/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTMAIN, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentMain = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitment/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTMAIN, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentMain = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrrecruitment/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTMAIN, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentMain = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrrecruitment/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTMAIN, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentCandidate = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidate/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTCANDIDATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentCandidate = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidate/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTCANDIDATE, payload: response.data, }); return response.data; }).catch(function (error) { console.log(error); return Promise.reject(error); });
};
export const updateHRRecruitmentCandidate = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrcandidate/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTCANDIDATE, payload: response.data, }); }).catch(function (error) { console.log(error); return Promise.reject(error); });
};
export const deleteHRRecruitmentCandidate = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrcandidate/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTCANDIDATE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentPipeline = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentpipeline/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPIPELINE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentPipeline = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentpipeline/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPIPELINE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentPipeline = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrrecruitmentpipeline/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPIPELINE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentPipeline = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrrecruitmentpipeline/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPIPELINE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getHRRecruitmentCandidateResume = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidateresume/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTCANDIDATERESUME, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentCandidateResume = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidateresume/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTCANDIDATERESUME, payload: response.data, }); return response.data; }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentCandidateResume = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrcandidateresume/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTCANDIDATERESUME, payload: response.data, }); }).catch(function (error) { console.log(error); return Promise.reject(error); });
};
export const deleteHRRecruitmentCandidateResume = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrcandidateresume/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTCANDIDATERESUME, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentInfo = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfo/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTINFO, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentInfoById = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfo/byid",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTINFOBYID, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentInfo = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfo/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTINFO, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentInfo = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrrecruitmentinfo/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTINFO, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentInfo = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrrecruitmentinfo/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTINFO, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentInfoHistory = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfohistory/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentInfoHistoryById = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfohistory/byid",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTINFOHISTORYBYID, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentInfoHistoryAllDetails = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfohistory/getalldetails",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTINFOHISTORYALLDETAILS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentInfoHistory = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrrecruitmentinfohistory/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  // return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
  return axios(config).then(function (response) {
    dispatch({ type: CREATEHRRECRUITMENTINFOHISTORY, payload: response.data, });
    console.log("historyResponse from action", response.data)
    return response.data;
  }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentInfoHistory = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrrecruitmentinfohistory/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: UPDATEHRRECRUITMENTINFOHISTORY, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentInfoHistory = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrrecruitmentinfohistory/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentCandidateNote = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidatenote/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTCANDIDATENOTE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentCandidateNote = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidatenote/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTCANDIDATENOTE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentCandidateNote = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrcandidatenote/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTCANDIDATENOTE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentCandidateNote = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrcandidatenote/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTCANDIDATENOTE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentCandidateEmail = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidateemail/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTCANDIDATEEMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentCandidateEmail = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidateemail/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTCANDIDATEEMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentCandidateEmail = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrcandidateemail/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTCANDIDATEEMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentCandidateEmail = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrcandidateemail/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTCANDIDATEEMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentPipelineSkillZone = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidateskillzone/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPIPELINESKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentPipelineSkillZone = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrcandidateskillzone/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPIPELINESKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentPipelineSkillZone = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrcandidateskillzone/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPIPELINESKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentPipelineSkillZone = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrcandidateskillzone/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPIPELINESKILLZONE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentSurveyResponse = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrjoblistingsurvey/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTSURVEYRESPONSE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentSurveyResponse = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrjoblistingsurvey/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTSURVEYRESPONSE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentSurveyResponse = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrjoblistingsurvey/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTSURVEYRESPONSE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentSurveyResponse = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrjoblistingsurvey/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTSURVEYRESPONSE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentHRMasterTask = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrmastertask/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTMASTERTASK, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentHRMasterTask = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrmastertask/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTMASTERTASK, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentHRMasterTask = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrmastertask/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTMASTERTASK, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentHRMasterTask = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrmastertask/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTMASTERTASK, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHREmail = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/hospitalNotification/email",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHREMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHREmail = (data) => (dispatch) => {
  var config = {
    method: "post", url: ServiceURL + "/api/hospitalNotification/email",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHREMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const SendSMS = (data) => (dispatch) => {
  var config = {
    method: "post", url: ServiceURL + "/api/hospitalNotification/sms",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: SENDHRSMS, payload: response.data, }); return response.data; }).catch(function (error) { console.log(error); throw error; });
};
export const updateHREmail = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/hospitalNotification/email",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHREMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHREmail = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/hospitalNotification/email",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHREMAIL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentHRPolicies = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrdeppolicies/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPOLICIES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentHRPolicies = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrdeppolicies/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPOLICIES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentHRPolicies = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrdeppolicies/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPOLICIES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentHRPolicies = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrdeppolicies/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPOLICIES, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentShiftRequests = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrstaffshift/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    const dataToStore = response.data.success === 1 ? response.data.data : [];
    dispatch({
      type: GETHRRECRUITMENTSHIFTREQUESTS,
      // payload: response.data,
      payload: { data: dataToStore },
    });
  }).catch(function (error) {
    console.log(error);
    dispatch({ type: GETHRRECRUITMENTSHIFTREQUESTS, payload: { data: [] } });
  });
};
export const createHRRecruitmentShiftRequests = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrstaffshift/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTSHIFTREQUESTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentShiftRequests = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrstaffshift/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTSHIFTREQUESTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentShiftRequests = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrstaffshift/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTSHIFTREQUESTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getHRRecruitmentPerformanceObjective = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceObjective/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPERFORMANCEOBJECTIVE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentPerformanceObjective = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceObjective/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPERFORMANCEOBJECTIVE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentPerformanceObjective = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setupHospitalHrPerformanceObjective/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPERFORMANCEOBJECTIVE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentPerformanceObjective = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setupHospitalHrPerformanceObjective/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPERFORMANCEOBJECTIVE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentPerformanceMeetings = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceMeetings/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPERFORMANCEMEETINGS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentPerformanceMeetings = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceMeetings/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPERFORMANCEMEETINGS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentPerformanceMeetings = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setupHospitalHrPerformanceMeetings/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPERFORMANCEMEETINGS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentPerformanceMeetings = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setupHospitalHrPerformanceMeetings/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPERFORMANCEMEETINGS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentPerformanceKRA = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceKRA/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPERFORMANCEKRA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentPerformanceKRA = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceKRA/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  // return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPERFORMANCEKRA, payload: response.data, }); }).catch(function (error) { console.log(error); });
  return axios(config).then(function (response) {
    dispatch({ type: CREATEHRRECRUITMENTPERFORMANCEKRA, payload: response.data });
    return response.data;

  }).catch(function (error) {
    console.log(error);
    throw error;
  });
};
export const updateHRRecruitmentPerformanceKRA = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setupHospitalHrPerformanceKRA/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPERFORMANCEKRA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentPerformanceKRA = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setupHospitalHrPerformanceKRA/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPERFORMANCEKRA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRRecruitmentPerformanceQA = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceQA/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRRECRUITMENTPERFORMANCEQA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRRecruitmentPerformanceQA = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setupHospitalHrPerformanceQA/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRRECRUITMENTPERFORMANCEQA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRRecruitmentPerformanceQA = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setupHospitalHrPerformanceQA/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRRECRUITMENTPERFORMANCEQA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRRecruitmentPerformanceQA = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setupHospitalHrPerformanceQA/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRRECRUITMENTPERFORMANCEQA, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHROffboardResignation = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehroffboardResignation/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHROFFBOARDRESIGNATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHROffboardResignation = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehroffboardResignation/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHROFFBOARDRESIGNATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHROffboardResignation = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehroffboardResignation/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHROFFBOARDRESIGNATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHROffboardResignation = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehroffboardResignation/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHROFFBOARDRESIGNATION, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRAssetsAll = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalhrmainassets/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRASSETSALL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRAssetsAll = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalhrmainassets/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRASSETSALL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRAssetsAll = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalhrmainassets/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRASSETSALL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRAssetsAll = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalhrmainassets/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRASSETSALL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const clearHRStaff = () => dispatch => {
  dispatch({
    type: CLEAR_HR_STAFF
  });
};

export const getHRAssetsList = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrassetslist/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRASSETSLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRAssetsList = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrassetslist/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRASSETSLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRAssetsList = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrassetslist/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRASSETSLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRAssetsList = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrassetslist/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRASSETSLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const createHRPayrollPayout = (data) => (dispatch) => {
  var config = {
    method: "post", url: ServiceURL + "/api/hospitalpayments/createpayouts",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYYROLLPAYOUT, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const InitiateLoanHRPayrollPayout = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/initiatePayout",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: INITIATELOANHRPAYOUT, payload: response.data, }); }).catch(function (error) { console.log(error); });
};


export const createHRPayrollAccure = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffpayrollinfo/createaccural",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYYROLLACCURE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const UpdateHRPayrollAccure = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffpayrollinfo/updateaccural",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: UPDATEHRPAYYROLLACCURE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const RevertHRPayrollAccure = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/AccountingEngine/reverseTnx",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: REVERTHRPAYYROLLACCURE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const SendHREmail = (data) => (dispatch) => {
  var config = {
    method: "post", url: ServiceURL + "/api/hospitalNotification/manualemail",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: SENDHRCUSTOMTEMPEMAIL, payload: response.data, }); return response.data; }).catch(function (error) { console.log(error); throw error; });
};

export const getHrPayrollLoanIssue = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRPAYROLLLOANISSUE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHrPayrollLoanIssue = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLLOANISSUE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const IssueHrPayrollLoanIssue = (data) => async (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphrstaffloans/issueLoan",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: ISSUEHRPAYROLLLOANISSUE,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return { success: 0, message: error.message };
  }
};
export const updateHrPayrollLoanIssue = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrstaffloans/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRPAYROLLLOANISSUE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHrPayrollLoanIssue = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphrstaffloans/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRPAYROLLLOANISSUE, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getHrPayrollLoanScheduleInformation = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRPAYROLLLOANSCHEDULEINFO, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHrPayrollLoanRepayManual = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/repayManual",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLLOANREPAYMANUAL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHrPayrollLoanRepayPayroll = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/repayPayroll",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLLOANREPAYPAYROLL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHrPayrollLoanPrepayFull = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/prepayFull",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLLOANPREPAYFULL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHrPayrollLoanPrepayPartial = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/prepayPartial",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLLOANPREPAYPPARTIAL, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHrPayrollLoanAddOnInterestLoan = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/intrestLoan",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRPAYROLLLOANADDONINTERESTLOAN, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getHRLoanDocuments = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrloandocuments/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRLOANDOCUMENTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRLoanDocuments = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrloandocuments/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRLOANDOCUMENTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRLoanDocuments = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrloandocuments/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRLOANDOCUMENTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRLoanDocuments = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrloandocuments/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRLOANDOCUMENTS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getHRLoanPolicyInfoHistory = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrloanpolicy/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRLOANPOLICYINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRLoanPolicyInfoHistory = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrloanpolicy/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRLOANPOLICYINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRLoanPolicyInfoHistory = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrloanpolicy/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRLOANPOLICYINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRLoanPolicyInfoHistory = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrloanpolicy/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRLOANPOLICYINFOHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getHRSetupACLList = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalaslcontrols/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRSETUPACLLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRSetupACLList = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalaslcontrols/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRSETUPACLLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRSetupACLList = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalaslcontrols/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRSETUPACLLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRSetupACLList = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalaslcontrols/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRSETUPACLLIST, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const raiseHRStaffLoanRequest = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloanrequests/raise",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: RAISE_HR_STAFF_LOAN_REQUEST, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

export const HRLoanProcessgenerateMandate = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloans/generateMandate",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: HRLOANGENERATEMANDATE, payload: response.data.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};

export const getHRStaffLoanRequests = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloanrequests/list",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: GET_HR_STAFF_LOAN_REQUESTS, payload: response.data.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};

export const getHRStaffLoanRequestDetails = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphrstaffloanrequests/details",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: GET_HR_STAFF_LOAN_REQUEST_DETAILS, payload: response.data.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};

export const approveHRStaffLoanRequest = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrstaffloanrequests/approve",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: APPROVE_HR_STAFF_LOAN_REQUEST, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

export const rejectHRStaffLoanRequest = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrstaffloanrequests/reject",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: REJECT_HR_STAFF_LOAN_REQUEST, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

export const cancelHRStaffLoanRequest = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphrstaffloanrequests/cancel",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: CANCEL_HR_STAFF_LOAN_REQUEST, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

// hr training setup

export const getHRTrainingHistory = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrtraininghistory/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRTRAININGHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRTrainingHistoryById = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrtraininghistory/byid",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRTRAININGHISTORYBYID, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getHRTrainingHistoryAllDetails = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrtraininghistory/getalldetails",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRTRAININGHISTORYALLDETAILS, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createHRTrainingHistory = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalehrtraininghistory/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRTRAININGHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateHRTrainingHistory = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalehrtraininghistory/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRTRAININGHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteHRTrainingHistory = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalehrtraininghistory/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEHRTRAININGHISTORY, payload: response.data, }); }).catch(function (error) { console.log(error); });
};


export const clearHrRecPipeline = () => ({ type: CLEAR_HR_RECPIPELINE, });
export const clearHrSetupACL = () => ({ type: CLEAR_HR_SETUPACL, });
export const clearHrInfoHistory = () => ({ type: CLEAR_HRINFOHISTORY, });
export const clearHrInfo = () => ({ type: CLEAR_HRINFO, });

